import {type Epic, ofType} from 'redux-observable';
import {ignoreElements, tap} from 'rxjs/operators';
// eslint-disable-next-line no-restricted-imports
import * as ReduxForm from 'redux-form';

import {combineEpics} from 'web-app/util/redux-observable';
import {type Action} from 'web-app/util/redux/action-types';
import {type RootState} from 'web-app/react/redux/main-reducer';

import {track} from './index';
import * as ActionTrackingConstants from './action-tracking-constants';
import {TrackingEvents} from './events';

const trackReduxFormsSubmit: Epic<Action<any>, any, RootState> = action$ => {
    return action$.pipe(
        ofType(ReduxForm.actionTypes.SET_SUBMIT_SUCCEEDED),
        tap(({meta}: any) => {
            const formName = meta.form;
            const mappedFormName = ActionTrackingConstants.reduxFormNamesToTrackingEventMap[formName];

            if (!mappedFormName) {
                return;
            }

            track(TrackingEvents.REDUX_FORM_SUBMITTED, {formName: mappedFormName});
        }),
        ignoreElements(),
    );
};

const trackActions: Epic<Action<any>, any, RootState> = action$ => {
    return action$.pipe(
        tap(action => {
            const eventName = ActionTrackingConstants.actionTypeToTrackingEventMap[action.type];

            if (!eventName) {
                return;
            }

            const trackingPayload = action.payload?.[ActionTrackingConstants.TRACK_ACTION_PAYLOAD_KEY] ?? {};
            track(eventName, trackingPayload);
        }),
        ignoreElements(),
    );
};

export default combineEpics(trackActions, trackReduxFormsSubmit);
